import {LocationService} from "../services/location.service.ts";

const ProcessHttp = () => {

    // Keeping this as may want middleware later
   
    return true;  
}

export { ProcessHttp };


export function logoutOfCMS(): void {
    const logoutForm = document.querySelector<HTMLFormElement>("#logoutForm");

    if (logoutForm) {
        logoutForm.submit();
    }
}

export function getLoginRelativePath(){
    const path = LocationService.getPathname()


    return `/account/login?returnUrl=${path}`
}